import { render } from "./PackageAnalysis.vue?vue&type=template&id=6f543f43&ts=true"
import script from "./PackageAnalysis.vue?vue&type=script&lang=ts"
export * from "./PackageAnalysis.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__